var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
    'resend-verification-code-form',
    {
      disabled: _vm.state.$busy
    }
  ],on:{"click":_vm.onSubmit}},[_vm._v("\n  "+_vm._s(_vm.state.$busy ? 'Resending...' : 'Resend')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }